import intercom from '../../../../utils/intercom';

const enableTemplate = require("./enable.html.slim");
declare var angular;
declare var window;

export class TwoFactorEnable {
  static $inject = ['$rootScope', '$scope', 'users']

  step: string;
  title: string;
  pillStep: number;
  tfaMethod: string;

  code: string;
  phone: string;
  qrCode: string;

  state: string;
  error: string;
  errorMaxRetries: string;
  backErrors: Array<string>;

  loading: string;

  constructor(
    public $rootScope,
    public $scope,
    private users
  ) {
    $rootScope.$on('enableTwoFactor', ((event, data) => {
      this.title = 'Set up Two-step verification';
      this.step = 'start';
      this.pillStep = 1;
      this.phone = data.phone;
      this.qrCode = '';
      this.state = '';
      this.error = '';
      this.errorMaxRetries = '';
      this.loading = '';
      this.tfaMethod = data.tfaMethod;
      /* Added this to watch for possible errors related to the phone number, so the dialog can move back to the phone number input if needed. */
      this.backErrors = ['Your number appears to be blocking our SMS messages. Text "YES" to 604-265-6699 to unblock us, then try again.',
      "That number isn't valid. Please enter a complete phone number, starting with its area code.",
      "Ce numéro n'est pas valide. Veuillez entrer un numéro de téléphone complet, en commençant par son indicatif régional.",
      "Please enter a North American phone number, starting with its area code.",
      "Please enter a SMS enabled phone number, starting with its area code.",
      "Something's not right. Please try again and let us know if the problem persists."];
      this.$scope.twoFactorEnableDialog.show();
    }));
  }

  rememberDevice() {
    this.users.rememberDeviceTwoFactorAuth()
      .then(() => {
         this.step = 'success'
         this.title = '';
         this.state = '';
         this.$rootScope.$emit("update_tfa_dashboard");
      })
      .catch((error) => {
        this.code = ''
        this.state = 'error'
        this.error = error.data.message;
      });
  }

  confirmCode(code) {
    this.state = "submitting";
    this.users.confirmTwoFactorAuth(code)
      .then(() => {
        this.code = null;
        this.state = '';
        this.$rootScope.$emit("update_tfa_dashboard");
        this.next('remember');
        this.title = 'Remember this device';
      })
      .catch((error) => {
        this.code = null;
        this.code = ''
        this.state = 'error'
        this.error = error.data.message;
      });
  }

  enableTwoFactor(phone) {
    this.users.enableTwoFactorAuth(phone, this.tfaMethod)
      .then(() => {
        this.state = '';
        if (this.tfaMethod === 'sms') { 
          this.next('confirm') 
        };
        if (this.tfaMethod === 'authenticator') {
          this.requestCode();
        }
      })
      .catch((error) => {
        this.state = 'error'
        this.error = error.data.message
      });
  }

  requestCode() {
    this.users.requestTwoFactorAuth()
      .then((resp) => {
        this.qrCode = resp
        this.next('qrCode')
      })
      .catch((error) => {
        this.state = 'error'
        this.error = error.data.message
      });
  }

  requestCodeAgain() {
    if(this.errorMaxRetries === '' || this.tfaMethod === 'authenticator'){
      if(this.tfaMethod === 'sms'){
        this.loading = "loading";
      }
      this.users.requestTwoFactorAuth()
        .then((resp) => {
          this.state = '';
          if (this.tfaMethod === 'authenticator') {
            this.qrCode = resp
          }else{
            this.loading = "loaded";
            this.state = '';
            this.error = '';
          }
        })
        .catch((error) => {
          this.loading = "";
          if (error.data.error_code && error.data.error_code === 'max_retries_reached') {
            this.errorMaxRetries = error.data.message;
            this.resetSendError();
          }else if(this.backErrors.includes(error.data.message)){
            this.state = 'error';
            this.error = error.data.message;
            this.back('start');
          }else{
            this.state = 'error';
            this.error = error.data.message;
          }
        });
    }
  }

  resetSendError() {
    setTimeout(() => {
      this.errorMaxRetries = '';
    }, 120000);
  }

  next(step) {
    this.state = '';
    this.error = '';
    this.step = step;
    if (this.tfaMethod === 'sms' && this.step == 'confirm') { 
      this.requestCodeAgain();
    }
    this.pillStep++;
  }

  back(step) {
    this.state = '';
    this.step = step;
    this.pillStep--;
  }

  openIntercomMessage() {
    this.$scope.twoFactorEnableDialog.cancel();
    intercom.show('showNewMessage');
  }
}

angular.module('wbComponents').directive('twoFactorAuthEnable', function() {
  return {
    restrict: 'E',
    templateUrl: enableTemplate,
    controller: TwoFactorEnable,
    controllerAs: 'enable',
    bindToController: true
  }
})
